import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function VersionHistoryIcon({ className, height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <path d="M6.633 11.221l1.133-.984a.75.75 0 1 1 .984 1.132l-2.402 2.088a.75.75 0 0 1-1.058-.074L3.203 10.98a.75.75 0 1 1 1.132-.984l.823.947a8.062 8.062 0 1 1 7.967 9.306.75.75 0 1 1 0-1.5 6.562 6.562 0 1 0-6.492-7.529zm9.867.777a.75.75 0 1 1 0 1.5h-3.938a.75.75 0 0 1-.75-.75V8.685a.75.75 0 1 1 1.5 0v3.313H16.5z" />
    </SimpleIcon>
  );
}
